import { InstrumentType } from '@/types/captable';

/**
 * Defines which fields are visible/relevant per instrument type.
 * Used by both the form and detail panel.
 */
export const INSTRUMENT_FIELD_CONFIG: Record<string, Set<string>> = {
  [InstrumentType.SAFE_PRE]: new Set(['valuation_cap', 'discount_rate']),
  [InstrumentType.SAFE_POST]: new Set(['valuation_cap', 'discount_rate']),
  [InstrumentType.CONVERTIBLE_NOTE]: new Set([
    'maturity_date',
    'interest_rate',
    'interest_method',
    'interest_accrual_frequency',
    'signing_date',
    'transfer_date',
    'valuation_cap',
    'discount_rate',
    'accrued_interest',
    'nav_including_interest',
    'runtime',
  ]),
  [InstrumentType.WARRANT]: new Set([
    'number_of_shares',
    'coverage_percentage',
    'strike_price',
    'fair_value',
    'maturity_date',
    'runtime',
  ]),
};
